module.exports = __webpack_public_path__ + "static/media/hit_horiz_2.e98ace4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hit_horiz_2.jpg
// module id = 125
// module chunks = 1